import * as React from 'react';

import PropTypes from 'prop-types';

// material
import { Box } from '@mui/material';
import { APP_CONSTANTS } from '../URLConstants';
import { useAuth } from './customContextProviders/AuthContext';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  const { userLoginOrg } = useAuth();

  let logoImage;

  switch (userLoginOrg) {
    case APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/bom-icon.png';
      break;

    case APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/cbi_icon.png';
      break;

    case APP_CONSTANTS?.IOB_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/iob_icon.png';
      break;

    case APP_CONSTANTS?.UJN_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/ujn_icon.svg';
      break;

    case APP_CONSTANTS?.KAGB_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/kagb_icon.png';
      break;

    case APP_CONSTANTS?.NPST_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/npst_logo.jpg';
      break;

    case APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER:
      logoImage = '/static/icons/sbi_logo.png';
      break;

    case APP_CONSTANTS?.COSMOS_CLIENT_IDENTIFIER:
      logoImage = '/assets/Cosmos/cosmos_icon.png';
      break;

    case APP_CONSTANTS?.PRATAP_CLIENT_IDENTIFIER:
      logoImage = '/assets/Pratap/pratap_icon.png';
      break;

    case APP_CONSTANTS?.RSB_CLIENT_IDENTIFIER:
      logoImage = '/assets/RSB/rsbIcon.png';
      break;

    case APP_CONSTANTS?.GBCB_CLIENT_IDENTIFIER:
      logoImage = '/assets/GBCB/gbcbicon.png';
      break;

    case APP_CONSTANTS?.HASTI_CLIENT_IDENTIFIER:
      logoImage = '/assets/HASTI/hasti-icon.png';
      break;

    default:
      logoImage = process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ICON;
  }

  return (
    <Box
      component="img"
      // src={
      //   process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
      //     ? sessionUserData?.organizationImage
      //     : process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ICON
      // }
      src={logoImage}
      sx={{ width: '70%', ...sx }}
    />
  );
}
